

export default [
    {
        path: "allotment/service",
        name: "serviceAllot",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/index"),
        meta: {
            keepAlive: true,
        }
    },
    {
        path: "allotment/service/boxing",
        name: "serviceAllotBoxing",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/boxing"),
    },
    {
        path: "allotment/service/update/:type",
        name: "serviceAllotUpdate",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/update"),

    },
    {
        path: "allotment/onsite",
        name: "onsiteAllot",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/onsiteallot/index"),
        meta: {
            keepAlive: true,
        }
    },
    {
        path: "allotment/onsite/boxing",
        name: "onsiteAllotBoxing",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/boxing"),
    },
    {
        path: "allotment/onsite/update/:type",
        name: "onsiteAllotUpdate",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/update"),
    },
    {
        path: "allotment/other",
        name: "otherAllot",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/otherallot/index"),
        meta: {
            keepAlive: true,
        }
    },
    {
        path: "allotment/other/boxing",
        name: "otherAllotBoxing",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/boxing"),
    },
    {
        path: "allotment/other/update/:type",
        name: "otherAllotUpdate",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/update"),
    },
    {
        path: "allotment/procure",
        name: "procureAllot",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/procurement/index"),
        meta: {
            keepAlive: true,
        }
    },
    {
        path: "allotment/procure/boxing",
        name: "procureAllotBoxing",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/boxing"),
    },
    {
        path: "allotment/procure/update/:type",
        name: "procureAllotUpdate",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/update"),
    },
    {
        path: "allotment/amazon",
        name: "amazonAllot",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/amazonallot/index"),
        meta: {
            keepAlive: true,
        }
    },
    {
        path: "allotment/amazon/boxing",
        name: "amazonAllotBoxing",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/boxing"),
    },
    {
        path: "allotment/amazon/update/:type",
        name: "amazonAllotUpdate",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/serviceallot/update"),
    },

    {
        path: "transfer/list",
        name: "tsList",
        component: () => import(/* webpackChunkName: "transfer" */ "@/views/allotment/transfer/list/index"),
    },
    {
        path: "transfer/list/update/:type",
        name: "tsUpdate",
        component: () => import(/* webpackChunkName: "transfer" */ "@/views/allotment/transfer/list/update"),
    },
    {
        path: "transfer/shipping",
        name: "tsShipping",
        component: () => import(/* webpackChunkName: "transfer" */ "@/views/allotment/transfer/shipping/index"),
    },

]